import {
  OidcIdentityProviderDto,
  OidcIdentityProvidersApi,
} from '../../../../api-client';
import { useQuery, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../../common';

const QUERY_KEY = 'oidc-providers';

type UseGetOidcProviders = (
  onError: (error: ErrorResponse) => void,
) => UseQueryResult<OidcIdentityProviderDto[]>;

export const useGetOidcProviders: UseGetOidcProviders = (onError) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const oidcIdentityProvidersApi = new OidcIdentityProvidersApi(getApiConfiguration());
  return useQuery(
    [QUERY_KEY],
    async () => oidcIdentityProvidersApi.getProviders(tenantId).then((res) => res.data),
    {
      retry: false,
      keepPreviousData: false,
      onError,
    },
  );
};
